module.exports = __webpack_public_path__ + "img/ring_y_l_1_0@2x.fc2b15e6.png";